export default import.meta.ROLLDOWN_FILE_URL_JaScB1CFutOi5bzoQ8DDJQ